import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const faqs = [
  ["How do I pay?", "By online banking. After you order you'll see our bank details and your order reference. Pop the reference in your transfer so we can match it up."],
  ["What's in a box?", "A mix of fresh fruit and veges. Contents change with the seasons and what's best that week."],
  ["Can I order more than one thing?", "Yes — add as many products as you like to one order, and pick how many of each."],
  ["Can I get a box every week?", "Yes — choose Weekly or Fortnightly when you order. Before each delivery we'll email you a reference to pay by online banking. To pause or cancel, just reply to any of our emails or give us a call."],
  ["Where do you deliver?", "Around Nelson. Enter your address and suburb when you order and we'll confirm delivery with you by email."],
];

export const Faq = () => (
  <section id="faq" className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 sm:px-10 md:py-32 lg:grid-cols-12" data-testid="faq-section">
    <Reveal className="lg:col-span-4">
      <Eyebrow>Questions</Eyebrow>
      <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-5xl">Good to know.</h2>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <Accordion type="single" collapsible className="border-t border-white/10">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-white/10">
            <AccordionTrigger className="py-7 text-left font-display text-xl font-bold tracking-tight hover:no-underline sm:text-2xl" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="pb-7 text-base text-[var(--sage)]">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
